export enum ContentTagType {
  SPACE = 'space',
  ORIENTATION = 'orientation',
  CONTENT_TAG = 'content-tag',
};
